import {BaseApiModel} from "../../../infrastructure/models/base-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {AthleteApiModel} from "../../common/athlete/athlete-api-model";
import {CompetitorApiModel} from "../../common/competitor/models/competitor-api-model";

export class AthletesResponseApiModel extends BaseApiModel {
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorApiModel>;
  athletes: Array<AthleteApiModel>;

  constructor(model: AthletesResponseApiModel) {

    super(model);
    this.countries = model.countries;
    this.sports = model.sports;
    this.competitions = model.competitions;
    this.competitors = model.competitors;
    this.athletes = model.athletes;
  }
}
